import type { Dispatch } from 'react';

import {
  Messages,
  MessageStatus,
  MessageType,
} from '../../components/Message/types/messages';

export interface TranscriptContextState {
  messages: MessageType[];
  sessionId: string;
  isAwaitingServerMessage: boolean;
  isSessionActive: boolean;
  loadFailed: boolean;
  initialMessage?: MessageType;
  /**
   * Set of messageIds with expanded sources (for vertical source list)
   * @optional - Only used when message sources are enabled
   */
  expandedSources?: Set<string>;
}

export enum TranscriptContextTypes {
  UPDATE_MESSAGES = 'UPDATE_MESSAGES',
  START_CHAT = 'START_CHAT',
  START_CHAT_FAIL = 'START_CHAT_FAIL',
  RESET_CHAT = 'RESET_CHAT',
  LOAD_SESSION = 'LOAD_SESSION',
  SEND_MESSAGE = 'SEND_MESSAGE',
  SEND_MESSAGE_FAIL = 'SEND_MESSAGE_FAIL',
  RESEND_MESSAGE = 'RESEND_MESSAGE',
  REACT_MESSAGE_LOCAL = 'REACT_MESSAGE',
  REACT_MESSAGE_FAIL = 'REACT_MESSAGE_FAIL',
  REACT_MESSAGE_SUCCESS = 'REACT_MESSAGE_SUCCESS',
  TOGGLE_SOURCES = 'TOGGLE_SOURCES',
}

export type TranscriptContextActionsMap = {
  [TranscriptContextTypes.UPDATE_MESSAGES]: Messages;
  [TranscriptContextTypes.START_CHAT]: null;
  [TranscriptContextTypes.RESET_CHAT]: string;
  [TranscriptContextTypes.START_CHAT_FAIL]: string;
  [TranscriptContextTypes.LOAD_SESSION]: string;
  [TranscriptContextTypes.SEND_MESSAGE]: { message: string; messageId: string };
  [TranscriptContextTypes.SEND_MESSAGE_FAIL]: string;
  [TranscriptContextTypes.RESEND_MESSAGE]: string;
  [TranscriptContextTypes.REACT_MESSAGE_LOCAL]: {
    messageId: string;
    status: MessageStatus;
  };
  [TranscriptContextTypes.REACT_MESSAGE_FAIL]: string;
  [TranscriptContextTypes.REACT_MESSAGE_SUCCESS]: {
    messageId: string;
    status: MessageStatus;
  };
  [TranscriptContextTypes.TOGGLE_SOURCES]: string;
};

export type TranscriptContextActions = {
  [k in keyof TranscriptContextActionsMap]: {
    type: k;
    payload: TranscriptContextActionsMap[k];
  };
}[keyof TranscriptContextActionsMap];

export type TranscriptContextDispatcher = Dispatch<TranscriptContextActions>;
